import { QueryClient } from '@tanstack/react-query';

// Query keys factory
export const QUERY_KEYS = {
  allNodes: () => ['nodes'] as const,
  node: (id: string) => ['nodes', id] as const,
  nodeMetrics: (id: string) => ['nodes', id, 'metrics'] as const,
  consensus: () => ['consensus'] as const,
  crdt: () => ['crdt'] as const,
  security: () => ['security'] as const,
  network: () => ['network'] as const,
  dashboard: () => ['dashboard'] as const,
  dashboardMetrics: () => ['dashboard', 'metrics'] as const,
  allAlerts: () => ['alerts'] as const,
};

// Invalidation helper
export function invalidateQueries(client: QueryClient, queryKey: readonly unknown[]) {
  return client.invalidateQueries({ queryKey });
}

// Browser detection removed - no longer needed with polling-only WebSocket

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if (error && typeof error === 'object' && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) {
            return false;
          }
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      networkMode: 'always', // Chrome bug: incorrectly detects offline state
    },
    mutations: {
      retry: 1,
      networkMode: 'always', // Chrome bug: incorrectly detects offline state
    },
  },
});